import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { SlideUpDown } from "../../../services/script"
import LogoImage from "../headers/common/logo"
import { connect } from "react-redux";
import { getFAQItems, getThemeColor,getAboutUs } from '../../../actions/home';
import { bindActionCreators } from "redux";

class FooterOne extends Component {
    
    componentDidMount() {
        var contentwidth = window.innerWidth;
        if ((contentwidth) < 750) {
            SlideUpDown('footer-title');
        } else {
            var elems = document.querySelectorAll(".footer-title");
            [].forEach.call(elems, function (elemt) {
                let el = elemt.nextElementSibling;
                el.style.display = "block";
            });
        }
        this.props.getFAQItems(this.props.connection_id);
        this.props.getAboutUs(this.props.connection_id);
    }
    

    themeBackground = () => {
        if(this.props.themeColor === 'Dark'){
            this.props.getThemeColor('Light');
        }
        else{
            this.props.getThemeColor('Dark');
        }
    }

    render() {
        const { customer_details, themeColor, presentURL, consumer_mobile_no } = this.props
        if (this.props.loading || this.props.faqContent === null) {
            return <div className="loading-cls"></div>
        }

        return (
            <>
            <footer className="footer-light">
                <div className="light-layout">
                    <div className="container">
                        {/* <section className="small-section border-section border-top-0">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="subscribe">
                                        <div>
                                            <h4>KNOW IT ALL FIRST!</h4>
                                            <p>Never Miss Anything From Multikart By Signing Up To Our Newsletter. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <form className="form-inline subscribe-form">
                                        <div className="form-group mx-sm-3">
                                            <input type="text" className="form-control" id="exampleFormControlInput1"
                                                   placeholder="Enter your email"/>
                                        </div>
                                        <button type="submit" className="btn btn-solid">subscribe</button>
                                    </form>
                                </div>
                            </div>
                        </section> */}
                    </div>
                </div>
                <section className="section-b-space light-layout">
                    <div className="container">
                        <div className="row footer-theme partition-f">
                            <div className="col-lg-4 col-md-6">
                                <div className="footer-title footer-mobile-title">
                                    <h4>about</h4>
                                </div>
                                <div className="footer-contant">
                                    <div className="footer-logo">
                                        <LogoImage logo={this.props.logo[0]} presentURL={presentURL}/>
                                    </div>
                                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, </p> */}
                                    <div className="footer-social">
                                        <ul style={{width:'100%',textAlign:'center'}}>


                                            {this.props.fb_link && this.props.fb_link.length > 0 ?
                                            <li>
                                            <a href={this.props.fb_link[0].APC_ELEMENT_CONTENT} target='_blank' ><i className="fa fa-facebook" style ={{background: 'lightgray',padding:15,borderRadius: '50%'}} aria-hidden="true"></i></a>
                                        </li>
                                            
                                            :''}
                                            {this.props.google_plus ?
                                            <li>
                                                <Link to='' ><i className="fa fa-google-plus" aria-hidden="true"></i></Link>
                                            </li> :'' }
                                            {this.props.twitter_link ? 
                                            <li>
                                                <Link to=''><i className="fa fa-twitter" aria-hidden="true"></i></Link>
                                            </li> : ''}
                                            {this.props.insta_link && this.props.insta_link.length > 0 ? 

                                            <li>
                                                <a href={this.props.insta_link[0].APC_ELEMENT_CONTENT} target='_blank'><i style ={{background: 'lightgray',padding:15,borderRadius: '50%'}} className="fa fa-instagram" aria-hidden="true"></i></a>
                                            </li>
                                            :''}
                                            {this.props.twitter_link ? 
                                            <li>
                                                <Link to=''><i className="fa fa-rss" aria-hidden="true"></i></Link>
                                            </li> : ''}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col offset-xl-1">
                                <div className="sub-title">
                                        consumer_mobile_no && 
                                        <div className="footer-title">
                                            <h4>my account</h4>
                                        </div>
                                    
                                    
                                    
                                    <div className="footer-contant">
                                        {this.props.isAuth ?
                                                consumer_mobile_no && 
                                                <ul>
                                                    <li><Link to={`/profile`} >Profile</Link></li>
                                                    <li><Link to={`/profile/my-orders`} >My Orders</Link></li>
                                                </ul>
                                            

                                            :
                                            <ul>
                                                <li><Link to={`/login`} >Login</Link></li>
                                                <li><Link to={`/login`} >Register</Link></li>
                                                <li><Link to={`/about`} >About Us</Link></li>
                                                <li><Link to={`/contact`} >Contact Us</Link></li>

                                            </ul>
                                        }
                                        {/* <ul>
                                                <li><Link to={`/login`} >Login</Link></li>
                                                <li><Link to={`/register`} >Register</Link></li>
                                                <li><Link to={`${this.props.isAuth ? '/profile' : '/login'}`} >Profile</Link></li>
                                                <li><Link to={`${this.props.isAuth ? '/profile/my-orders' : '/login'}`} >My Orders</Link></li>
                                                <li><Link to={`${this.props.isAuth ? '/profile/change-password' : '/login'}/`} >Forgot Password</Link></li>
                                        </ul> */}
                                    </div>
                                </div> 
                            </div>
                            <div className="col">
                                <div className="sub-title">
                                    <div className="footer-title">
                                        <h4>terms and conditions</h4>
                                    </div>
                                    <div className="footer-contant">
                                        <ul>
                                            {/* <li><a>shipping & return</a></li>
                                            <li><a>secure shopping</a></li>
                                            <li><a>contacts</a></li> */}
                                            {
                                                Object.keys(this.props.faqContent).map(key => {
                                                  if(key !== 'AboutUs') {
                                                    return (
                                                        <li key={key} >
                                                            {key !== 'AboutUs' &&
                                                            <Link to={`/faq/${key}`} style={{textTransform:'none'}}>
                                                                {key}
                                                            </Link> }
                                                        </li>

                                                    )
                                                  }
                                                })
                                            
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="sub-title">
                                    <div className="footer-title">
                                        <h4>Corporate Office</h4>
                                    </div>
                                    {/* <div className="footer-contant" >
                                        <Link to={`/contact`} style={{color:'black'}}>Contact Us</Link>
                                    </div> */}
                                    <div className="footer-contant">
                                        <ul className="contact-list" style={{paddingBottom:10}}>
                                            <li><i className="fa fa-map-marker"></i>{customer_details.STE_CORPORATE_ADDRESS1} {customer_details.STE_CORPORATE_ADDRESS2} {customer_details.STE_CORPORATE_ADDRESS3}
                                            </li>
                                            <li>{customer_details.STE_CORPORATE_CITY_NAME}, {customer_details.STE_CORPORATE_STATE_NAME}, {customer_details.STE_CORPORATE_COUNTRY_NAME} - {customer_details.STE_CORPORATE_PIN}
                                            </li>
                                            <li><i className="fa fa-phone"></i>Call Us: {customer_details.STE_CORPORATE_CONTACT_NO}</li>
                                            <li><i className="fa fa-envelope-o"></i>Email Us: <a
                                            >{customer_details.STE_CORPORATE_EMAIL_ID}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="sub-footer ">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-md-6 col-sm-12">
                                <div className="footer-end">
                                    <p><i className="fa fa-copyright" aria-hidden="true"></i> 2020
                                        powered by Olabi</p>
                                </div>
                            </div>
                            {/* <div className="col-xl-6 col-md-6 col-sm-12">
                                <div className="payment-card-bottom">
                                    <ul>
                                        <li>
                                            <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/visa.png`} alt="" /></a>
                                        </li>
                                        <li>
                                            <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/mastercard.png`} alt="" /></a>
                                        </li>
                                        <li>
                                            <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/paypal.png`} alt="" /></a>
                                        </li>
                                        <li>
                                            <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/american-express.png`} alt="" /></a>
                                        </li>
                                        <li>
                                            <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/icon/discover.png`} alt="" /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </footer>
            {/* for theme background color */}
           {/*  <div>
                <div className="sidebar-btn dark-light-btn">
                    <div className="dark-light">
                        <div className="theme-layout-version" onClick={() => this.themeBackground()}>
                            {this.props.themeColor === '' ? 'Dark' : this.props.themeColor === 'Dark' ? 'Light' : 'Dark'}
                        </div>
                    </div>
                </div>
            </div> */}
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        logo: state.tenant.tenantLogoURL,
        isAuth: state.user.isAuth,
        connection_id: state.tenant.connection_id,
        loading: state.landing.faqLoading,
        error: state.landing.error,
        faqContent: state.landing.faqContent || {},
        customer_details: state.tenant.tenant_details,
        fb_link : state.tenant.header_and_store_content.filter(item => item.APC_ELEMENT_ID === "Footer Link - FB") || null,
        insta_link : state.tenant.header_and_store_content.filter(item => item.APC_ELEMENT_ID === "Footer Link - Insta") || null,
        themeColor: state.landing.themeColor,
        presentURL: state.tenant.presentURL,
        consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    }
}

export default connect(mapStateToProps, { getFAQItems,getAboutUs, getThemeColor }
)(FooterOne);